import { Box, Heading, Text } from '@chakra-ui/react';
import { AppLink } from '@/lib/router';

export function NotFoundPage() {
  return (
    <Box as="main" id="main">
      <Box px={{ base: '5', md: '8' }} pt={{ base: '16', md: '24' }} pb="24">
        <Box maxW="4xl" mx="auto">
          <p className="kicker">404</p>
          <Heading as="h1" color="fg" fontSize={{ base: '4xl', md: '6xl' }} letterSpacing="-0.05em" mb="6">
            Page not found.
          </Heading>
          <Text className="soft" mb="8">
            That URL doesn’t exist.
          </Text>
          <AppLink href="/" className="btn">
            Back home
          </AppLink>
        </Box>
      </Box>
    </Box>
  );
}
